import React from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const Intro = () => {
  return (
    <div className={cx('wrap')}>
      <span className={cx('title')}>
        <strong>취업 성공률</strong>을 높이세요!
      </span>
      <div className={cx('desc')}>
        <span className={cx('period')}>참여기간</span>
        <span className={cx('date')}>2024.04.01(월) ~ 2024.04.30(화)</span>
        <span className={cx('period')}>혜택 지급</span>
        <span className={cx('date')}>2024.05.07.(화) 이내</span>
      </div>
      <span className={cx('subText')}>
        프로필 신규 작성 / 기존 프로필 업데이트 시<span className={cx('import')}>취업지원금 제공!</span>
      </span>
    </div>
  );
};

export default Intro;
